import { authorizedAccounts } from "app/containers/Auth/data";
import {
  ENUM_USER_TIME_FORMAT,
  ENUM_USER_WEEK_START,
} from "app/containers/Features/containers/TeamSettings/container/MySetting/types";
import { defaultAvatar } from "app/containers/Features/containers/TeamSettings/redux/initialState";
import {
  AppHomeState,
  ENUM_USER_DATE_FORMAT,
  IPagination,
  ITeamSettings,
  IUserData,
  IWorkSpaceDetails,
  IWorkspaceTeams,
  ProjectStatus,
  sortOrder,
  userOnboardingStage,
} from "app/types";

export const defaultPagination: IPagination = {
  page: 1,
  perPage: 10,
  orderBy: "",
  orderDirection: sortOrder.ASC,
  total: 0,
  totalPage: 0,
};
const defaultUserFormData: IWorkSpaceDetails = {
  _id: "",
  teams: [],
  teamIds: [],
};

const defaultUserData: IUserData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  email: "",
  isActive: false,
  avatar: { ...defaultAvatar },
  userOnboardingProgress: userOnboardingStage.CODE_VERIFICATION,
  language: "",
  timeFormat: ENUM_USER_TIME_FORMAT.TWELVE_HOUR,
  dateFormat: ENUM_USER_DATE_FORMAT.MM_DD_YYYY,
  weekStart: ENUM_USER_WEEK_START.SUNDAY,
  isInvited: false,
  fullName: "",
  timeZone: "",
  lastLoginDate: "",
  selectedProjectId: "",
  selectedTeamId: "",
  mobileNumber: "",
  mutedTill: "",
};
export const defaultWorkspaceTeams: IWorkspaceTeams = {
  _id: "",
  teamName: "",
  avatar: { ...defaultAvatar },
  projects: [],
  teamMembers: [],
};
export const defaultWorkspaceTeamsSetting: ITeamSettings = {
  _id: "",
  teamName: "",
  teamMembers: [],
  projects: [],
  ticketTypes: [],
  ticketStatus: [],
  rawSettings: {
    groups: [],
    visibleGroups: [],
    subGroups: [],
    groupByData: [],
    subGroupByData: [],
    customizeCardsData: [],
  },
};

export const initialState: AppHomeState = {
  isAuthenticated: localStorage.getItem("accessToken") ? true : false,
  authorizedAccounts: authorizedAccounts,
  drawerOpen: { actions: false },
  loading: false,
  error: null,
  project: null,

  userOnboardingProgress: null,
  access_token: localStorage.getItem("accessToken"),
  userFormData: { ...defaultUserData },
  workSpaceDetails: {
    ...defaultUserFormData,
  },
  selectedTeam: { ...defaultWorkspaceTeams },
  isBoardCreate: false,
  workspaceTeamsSetting: [],
  // selectedProjectSetting: { ...defaultSelectedProjectSetting },
  isBoardLoading: false,
  boards: [],
  isBoardMenuLoading: false,
  boardMenuData: [],
  isArchiveLoading: false,
  isCollapseSidebarMenu: false,
  createTeamModal: false,
  createProjectModal: false,
  selectedTeamLoading: false,
  projectSettingDetails: {
    _id: "",
    name: "",
    lead: "",
    status: ProjectStatus.ACTIVE,
    isArchived: false,
    ticketTypes: [],
    ticketStatuses: [],
    ticketTags: [],
  },
  globalSearchModal: false,
  notificationDrawerOpen: false,
  isTimeSheetEnabled: false,

  // Timer State
  timeTracker: {
    startTime: null,
    elapsed: 0,
    isRunning: false,
  },
};
